import React from 'react';
import '../_style/circularloader.css'; // We'll create this CSS file next

/**
 * A circular loading spinner component.
 * @param {object} props - The component's props.
 * @param {string} [props.size='40px'] - The width and height of the spinner.
 * @param {string} [props.thickness='4px'] - The thickness of the spinner's border.
 * @param {string} [props.color='#0DD3AF'] - The color of the active part of the spinner (theme color).
 * @param {string} [props.trailColor='rgba(0, 0, 0, 0.1)'] - The color of the spinner's trail.
 * @param {string} [props.className=''] - Additional CSS classes for the container.
 * @param {object} [props.style={}] - Custom inline styles for the container.
 */
const CircularLoader = ({
  size = '40px', // Default size
  thickness = '4px', // Default thickness
  color = '#0DD3AF', // Default theme color (Jobam green)
  trailColor = 'rgba(0, 0, 0, 0.1)', // Default trail color (light grey)
  className = '',
  style = {}
}) => {
  const spinnerStyle = {
    borderWidth: thickness,
    borderTopColor: color,
    borderColor: trailColor, // Base border color for the trail
    borderTopColor: color,   // Active part of the spinner
  };

  return (
    <div className={`circular-loader-container ${className}`} style={style}>
      <div className="circular-spinner"></div>
    </div>
  );
};

export default CircularLoader;
